export default "__VITE_ASSET__sUf1772M__"